export const AddCart = "AddCart"
export const AddAddress = "AddAddress"
export const CartReset="CartReset"

export const TotalPrice="TotalPrice"
export const TotalItems = "TotalItems"
export const TotalWishtList = "TotalWishtList"
